/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const typeMessageEnumSchema = z
	.enum(["interactiveButtonsResponse", "textMessage"])
	.describe("* `interactiveButtonsResponse` - Interactive Buttons Response\n* `textMessage` - Text Message");
